// Wrap de rutas que requieren session valida. Si no hay session, redirige
// a /login guardando la ruta original en `state.from` para volver despues.
//
// NO valida contra el backend aca — eso lo hace el primer fetch dentro de
// la ruta (y si el backend devuelve 401, lib/api.ts limpia la session y
// el componente re-renderea vacio → redirect).

import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useSession } from '@/hooks/useSession';

export default function ProtectedRoute({ children }: { children: ReactNode }): JSX.Element {
  const session = useSession();
  const location = useLocation();

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
